module.exports = __webpack_public_path__ + "static/media/offline-icon.f0a1ec3d.svg";